import axios from "axios";

export default axios.create({
  baseURL:
    process.env[`REACT_APP_REQUEST_CASE_${process.env.REACT_APP_ENVIROMENT}`],
  headers: {
    "Content-type": "application/json",
  },
});
